import { ScrollFadeIn } from "@/components/effects/ScrollFadeIn";
import { Marquee } from "@/components/ui/marquee";
import lovableLogo from "@/assets/logos/lovable.png";
import claudeLogo from "@/assets/logos/claude.png";
import supabaseLogo from "@/assets/logos/supabase.png";
import vercelLogo from "@/assets/logos/vercel.png";
import chatgptLogo from "@/assets/logos/chatgpt.png";
import geminiLogo from "@/assets/logos/gemini.png";
import replitLogo from "@/assets/logos/replit.png";

const aiTools = [
  { name: "Lovable", logo: lovableLogo },
  { name: "Cursor", logo: "https://www.cursor.com/apple-touch-icon.png" },
  { name: "Supabase", logo: supabaseLogo },
  { name: "Claude", logo: claudeLogo },
  { name: "Vercel", logo: vercelLogo },
  { name: "ChatGPT", logo: chatgptLogo },
  { name: "Gemini", logo: geminiLogo },
  { name: "Replit", logo: replitLogo },
];

const WhyUs = () => {
  return (
    <section className="py-32 px-4 relative overflow-hidden">
      {/* Ambient background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/[0.02] to-transparent" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-3xl opacity-50" />
      
      <div className="max-w-5xl mx-auto relative z-10">
        <ScrollFadeIn>
          <div className="text-center mb-16">
            <p className="text-primary font-medium text-sm uppercase tracking-widest mb-4">
              Our Approach
            </p>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 font-heading tracking-tight">
              We're <span className="text-gradient-indigo">AI Native</span>
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg leading-relaxed">
              We leverage cutting-edge AI tools to build at unmatched speed—combining automation with real engineering best practices to deliver production-ready products.
            </p>
          </div>

          {/* AI Tools scrolling carousel */}
          <div className="relative">
            {/* Gradient fade edges */}
            <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

            <Marquee
              items={aiTools}
              speedSeconds={20}
              renderItem={(tool) => (
                <div className="flex-shrink-0 px-4 md:px-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-card/50 backdrop-blur-sm border border-border/30 flex items-center justify-center shadow-soft hover:shadow-glow hover:border-primary/40 transition-all duration-500">
                    <img
                      src={tool.logo}
                      alt={tool.name}
                      loading="lazy"
                      decoding="async"
                      className="w-10 h-10 md:w-12 md:h-12 object-contain"
                    />
                  </div>
                </div>
              )}
            />
          </div>

        </ScrollFadeIn>
      </div>
    </section>
  );
};

export default WhyUs;
